module.exports = __webpack_public_path__ + "static/media/triange.af9ff64c.svg";